import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: 0.3rem;
  padding: 0.41rem;
`
